(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const menuToggle = $("[data-menu-toggle]");
  const mobileNav = $("[data-mobile-nav]");
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", () => {
      const open = mobileNav.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", String(open));
    });
  }

  const thumbs = $$("[data-product-thumb]");
  const mainImage = $("[data-product-main-image]");
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      if (!mainImage) return;
      const src = thumb.getAttribute("data-src");
      const srcset = thumb.getAttribute("data-srcset");
      const alt = thumb.getAttribute("data-alt") || "";
      if (src) mainImage.src = src;
      if (srcset) mainImage.srcset = srcset;
      mainImage.alt = alt;
      thumbs.forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
    });
  });

  const sizeButtons = $$("[data-size-option]");
  const variantInput = $("[data-variant-input]");
  const addButton = $("[data-add-to-cart]");
  const priceEl = $("[data-product-price]");

  sizeButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      sizeButtons.forEach((b) => b.classList.remove("is-selected"));
      btn.classList.add("is-selected");
      if (variantInput) variantInput.value = btn.getAttribute("data-variant-id");
      const available = btn.getAttribute("data-available") === "true";
      if (addButton && !addButton.hasAttribute("data-coming-soon")) {
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.getAttribute("data-add-label") : addButton.getAttribute("data-sold-label");
      }
      if (priceEl && btn.getAttribute("data-price")) {
        priceEl.textContent = btn.getAttribute("data-price");
      }
    });
  });

  const cards = $$("[data-product-card]");
  const countEl = $("[data-collection-count]");
  const colorPills = $$("[data-filter-color]");
  const sizePills = $$("[data-filter-size]");
  let activeColor = "all";
  let activeSize = "all";

  function applyFilters() {
    let visible = 0;
    cards.forEach((card) => {
      const color = (card.getAttribute("data-color") || "").toLowerCase();
      const sizes = (card.getAttribute("data-sizes") || "").toLowerCase().split(",");
      const colorOk = activeColor === "all" || color === activeColor;
      const sizeOk = activeSize === "all" || sizes.includes(activeSize);
      const show = colorOk && sizeOk;
      card.classList.toggle("is-hidden", !show);
      if (show) visible += 1;
    });
    if (countEl) {
      countEl.textContent = visible === 1 ? "1 product" : visible + " products";
    }
  }

  colorPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      activeColor = pill.getAttribute("data-filter-color");
      colorPills.forEach((p) => p.classList.toggle("is-active", p === pill));
      applyFilters();
    });
  });

  sizePills.forEach((pill) => {
    pill.addEventListener("click", () => {
      activeSize = pill.getAttribute("data-filter-size");
      sizePills.forEach((p) => p.classList.toggle("is-active", p === pill));
      applyFilters();
    });
  });
})();
